import React, { PureComponent } from "react";
import { FloatingActionButton, Divider } from "material-ui";
import ContentAdd from "material-ui/svg-icons/content/add";
import ContentRemove from "material-ui/svg-icons/content/remove";
import { Field, FieldArray } from "redux-form";
import {
	TextField,
	DatePicker,
	Checkbox,
	SelectField
} from "redux-form-material-ui";
import Util from "../../common/Util";
import UtilPC from "../../common/UtilPC";
import { typeIntegerOrDecimal, required } from "../../common/validaciones";
import "./AddPayment.css";

let indexMax = 0;

class AddPayment extends PureComponent {
	constructor() {
		super();
		this.state = {
			addPayment: false
		};
		this.renderFields = this.renderFields.bind(this);
	}
	componentWillMount() {
		indexMax = 0;
	}
	componentDidMount() {
		this.setState({
			addPayment: this.props.addDisabled
		});
	}
	onCheckChange() {
		this.setState({
			addPayment: !this.state.addPayment
		});
	}
	renderFields({ fields }) {
		// eslint-disable-next-line
		fields.length > 1 ? (indexMax = fields.length) : null;
		return (
			<div className="top20">
				<div
					className="columns-row-between align-center"
					style={{ marginTop: "2%" }}
				>
					<div className="titlePhoneContainer">
						<h4
							className="titleAddPhone text-center"
							style={{ color: "#70787d" }}
						>
							Agregar Pagos
						</h4>
						<Divider className="top10" />
					</div>
					<FloatingActionButton
						zDepth={1}
						onClick={() => fields.push()}
						disabled={
							this.props.disabled ? this.props.disabled : this.state.addPayment
						}
					>
						<ContentAdd />
					</FloatingActionButton>
				</div>
				<div className="columns-row-container">
					{fields.map((payment, index) => (
						<div
							key={index}
							className="columns-column-between columns-full align-center bottom20"
						>
							<div className="columns-row-between align-center">
								<Field
									name={`${payment}.${this.props.nameFieldPaymentDate}`}
									component={DatePicker}
									floatingLabelText="Fecha del Pago"
									format={Util.isoDateToJavascriptDate}
									DateTimeFormat={Intl.DateTimeFormat}
									locale="es-ES"
									maxDate={new Date()}
									parse={v => Util.formatDateToISODate(v)}
									validate={[required]}
									disabled={this.props.disabled ? this.props.disabled : false}
								/>
								<Field
									name={`${payment}.${this.props.nameFieldPayment}`}
									component={TextField}
									floatingLabelText="Total Pagado $"
									className="left20"
									validate={[typeIntegerOrDecimal, required]}
									disabled={this.props.disabled ? this.props.disabled : false}
								/>
							</div>
							<Field
								name={`${payment}.${this.props.nameFieldPaymentMethod}`}
								component={SelectField}
								floatingLabelText="Forma de Pago"
								fullWidth
								validate={required}
								disabled={this.props.disabled ? this.props.disabled : false}
							>
								{this.props.paymentMethodsList.map(item =>
									UtilPC.renderSelectFieldItem(
										item.id,
										`${item.agreement} - ${item.name}`
									)
								)}
							</Field>
							{indexMax - 1 === index || indexMax === index ? (
								<div className="columns-row-around columns-full align-center top30">
									<Field
										name={`${payment}.${this.props.nameFieldCompletesPayment}`}
										component={Checkbox}
										label="Pago Completo?"
										style={{ width: "50%" }}
										onCheck={this.onCheckChange.bind(this)}
										disabled={this.props.disabled ? this.props.disabled : false}
									/>
									<FloatingActionButton
										mini
										backgroundColor="#F44534"
										zDepth={1}
										disabled={this.props.disabled ? this.props.disabled : false}
										onClick={() => {
											fields.remove(index);
											indexMax--;
											this.setState({
												addPayment: false
											});
										}}
									>
										<ContentRemove />
									</FloatingActionButton>
								</div>
							) : null}
						</div>
					))}
				</div>
			</div>
		);
	}

	render() {
		return (
			<FieldArray
				name={this.props.nameFieldArray}
				component={this.renderFields}
				disabled={this.props.disabled ? this.props.disabled : false}
			/>
		);
	}
}

export default AddPayment;



// WEBPACK FOOTER //
// ./src/components/AddPayment/AddPayment.js